module.exports = __webpack_public_path__ + "static/img/gen_root2.97fa76e3.jpg";